import React, { Component } from 'react';
import { Error404 } from '@/components/custom/error';

export default class Notfound extends Component {
  render() {
    return <Error404 />;
  }
}
